export default __webpack_public_path__ + "static/media/web-2-inverted.58704103.png";